export default __webpack_public_path__ + "static/media/job_offer11_xl.dc713509.jpg";